import Link from 'next/link';
 import Icon from'@/components/ui/AppIcon';

const FinalCTASection = () => {
  return (
    <section className="py-32 bg-gradient-to-b from-background to-white">
      <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
        <div className="reveal">
          {/* Emoji */}
          <div className="text-6xl mb-6">🚀</div>

          {/* Headline */}
          <h2 className="text-5xl md:text-6xl font-bold font-montserrat text-foreground mb-6 leading-tight">
            Build Your Business <span className="text-primary">Anywhere</span>
          </h2>

          {/* Subheadline */}
          <p className="text-lg text-muted-foreground mb-12 max-w-2xl mx-auto leading-relaxed">
            Ready to transform your vision into reality? Get started with a custom quote or book a free consultation with our team.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              href="/get-a-quote"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground font-semibold rounded-full px-8 py-4 sm:py-5 hover:bg-primary/90 transition-all hover:scale-[0.98] shadow-lg touch-manipulation min-h-[56px] text-base sm:text-lg"
            >
              Get a Quote
              <Icon name="DocumentTextIcon" size={20} />
            </Link>
            <Link
              href="/book-appointment"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-white border-2 border-primary text-primary font-semibold rounded-full px-8 py-4 sm:py-5 hover:bg-primary/10 transition-all touch-manipulation min-h-[56px] text-base sm:text-lg"
            >
              <Icon name="CalendarIcon" size={20} />
              Book an Appointment
            </Link>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap items-center justify-center gap-8 mt-16 text-sm text-muted-foreground">
            <div className="flex items-center gap-2">
              <Icon name="CheckCircleIcon" size={20} className="text-success" />
              <span>Free Consultation</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="CheckCircleIcon" size={20} className="text-success" />
              <span>Nationwide Delivery</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="CheckCircleIcon" size={20} className="text-success" />
              <span>Turn-Key Solutions</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FinalCTASection